import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'FontAwesome',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/webfonts/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  backgroundContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    height: 217,
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 600,
    height: 217,
  },
  overlayContent: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    fontSize: 11,
    color: 'white',
    padding: 4,
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    marginTop: 10,
    width: '100%',
  },

  contentWrapper: {
    marginTop: 20,
    marginLeft: 53,
    marginRight: 53,
  },

  boldText: {
    color: '#27343d',
    fontSize: 11,
    lineHeight: 1.5,
    fontFamily: 'Lato',
    fontWeight: 900,
  },
  text: {
    color: '#27343d',
    fontSize: 11,
    lineHeight: 1.5,
    fontWeight: 400,
  },

  icon: {
    color: '#27343d',
    fontFamily: 'FontAwesome',
    fontSize: 18,
    marginRight: 8,
  },
  itemWrapper: {
    marginBottom: 30,
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  leftColumn: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '35%',
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Lato',
    color: '#27343d',
  },
  itemImage: {
    width: '100%',
    maxWidth: 350,
    height: 120,
    objectFit: 'cover',
    borderRadius: 4,
  },
  fullRow: {
    marginTop: 10,
  },
  itemDescription: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
  },
  itemListItem: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
  },
  bullet: {
    fontSize: 9,
    fontFamily: 'Lato',
    marginRight: 4,
    color: '#27343d',
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: 10,
    width: '100%',
  },
  buttonText: {
    backgroundColor: '#ffffff',
    border: '2px solid #27343d',
    borderRadius: 4,
    color: '#27343d',
    fontSize: 9,
    fontFamily: 'Lato',
    textAlign: 'center',
    textDecoration: 'none',

    paddingVertical: 4,
    paddingHorizontal: 12,
  },
});
